import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwMetaDataFormStateService, DwContainerOptions, isEmptyObject, DwLookupInfo, DwDefaultListPageComponent, DwCardBaseComponent } from '@devwareapps/devware-cap';
import { NgbTypeaheadWindow } from '@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window';
import { map, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { values } from 'underscore';
import { EmployeeReviewCategories } from '../../meta-data/constants/employee-review-categories.enum';
import { EmployeeReviewQuestionSetupLevel } from '../../meta-data/constants/employee-review-question-setup-level.enum';
import { EmployeeReviewAnswerEntity, EmployeeReviewAnswerValueEntity, EmployeeReviewEntity, EmployeeReviewQuestionEntity, PerformanceManagementMetaDataItemNames, PerformanceManagementMetaDataService, EmployeeReviewQuestionSetupEntity, PerformanceManagementMetaDataLookups } from '../../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewQuestionData } from '../../models/employee-review-question-data.model';
import { PerformanceManagementRepositoryService } from '../../services/performance-management-repository.service';

@DwComponent(
  {
    key: 'employee-review-question-setup-card',
    name: 'Employee Review Question Setup Card',
    componentType: DwComponentType.card,
    isGlobal: false,
    parentItemName: PerformanceManagementMetaDataItemNames.EmployeeReviewQuestionSetup,
  }
)
@Component({
  selector: 'app-employee-review-question-setup-card',
  templateUrl: './employee-review-question-setup-card.component.html',
  styleUrls: ['./employee-review-question-setup-card.component.scss']
})
export class EmployeeReviewQuestionSetupCardComponent implements DwCardBaseComponent<any, EmployeeReviewQuestionSetupEntity> {
  
  cardConfig?: any;
  data?: EmployeeReviewQuestionSetupEntity;
  resolvedContext?: any;

  cardClick = new EventEmitter<any>();
  levels: DwLookupPropertyObject = {};

  showAdd: boolean = false;

  showHideBidding: boolean = false;
  showHideRevenue: boolean = false;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
  private perfMonRepo: PerformanceManagementRepositoryService) {

    this.dwMetaDataService.getLookup(PerformanceManagementMetaDataLookups.EmployeeReviewQuestionSetupLevelAllItems)
      .subscribe(levels => {
        this.levels = this.translateLevels(levels);
      })

  }

  translateLevels(levels: DwLookupInfo[]): DwLookupPropertyObject {
    const levelInfo: DwLookupPropertyObject = {};
    

    for(let level of levels) {
      levelInfo[level.Id] = level;
    }

    return levelInfo;
    
  }

  setupCard() {
    // Nothing to setup

    this.showAdd = false;

    if (!this.data?.EmployeeReviewQuestionSetupId || this.data?.EmployeeReviewQuestionSetupDetail?.length == 0) {
      this.showAdd = true;
    }  

    if (this.data?.EmployeeReviewQuestionSetupLevelId == EmployeeReviewQuestionSetupLevel.global) {
      this.showHideBidding = this.showHideRevenue = false;
      return;
    }

    if (this.data?.EmployeeReviewQuestionSetupLevelId == EmployeeReviewQuestionSetupLevel.department) {
      this.showHideBidding = this.data?.HideBiddingQuestions;
      this.showHideRevenue = this.data?.HideRevenueQuestions;

      return;
    }

    if (this.data?.EmployeeReviewQuestionSetupLevelId == EmployeeReviewQuestionSetupLevel.team) {
      this.showHideBidding = this.data?.HideBiddingQuestions;
      this.showHideRevenue = this.data?.HideRevenueQuestions;
      
      return;
    }
  }
  
  onCardClick() {

    if (this.data.EmployeeReviewQuestionSetupId) {
      this.cardClick.emit(this.data);
    }


    this.perfMonRepo.createEmployeeReviewQuestionSetup(this.data)
      .subscribe(result => {
        this.data = result;

        this.cardClick.emit(this.data);

      });
  
  
  }
}


export declare class DwLookupPropertyObject {
  [prop: string] : DwLookupInfo;
}
